import React from 'react';
import s from '../Cart.module.css';

interface SummaryRowProps {
	label: string;
	value: string | number;
}

const SummaryRow: React.FC<SummaryRowProps> = ({label, value}) => {
	return (
		<div className={s.summaryRow}>
			{label}:
			<span className={s.summaryValue}>{value}</span>
		</div>
	);
};

export default SummaryRow;

